import { getHost } from '../../config/api';

export const API = getHost() + "/api/v1";

/**
 * 可判断订单是不是 "新"
 * 6 小时之内
 */
export const orderNewTime = 6;